export default __webpack_public_path__ + "static/Panasonic_MN34229_Day-64b1369052418e3c679c52e10429bada.webp";